import { getCurrentInstance } from 'vue'
import { PublicClientApplication } from '@azure/msal-browser'

export const useMsal = (config) => {
  const vm = getCurrentInstance()
  const instance = new PublicClientApplication(config)
  vm.appContext.config.globalProperties.$msalInstance = instance
  return vm.appContext.config.globalProperties.$msalInstance
}
